<ng-container *transloco="let t">
  <div [class.admin-template]="isAdmin">
    @if (showEmptyState || competitorTableData.length > 0) {
      @if (showHeader) {
        <div>
          <app-races-header [cssClass]="'small'" [defaultLanguage]="event?.defaultLanguage" [isAdmin]="isAdmin"
                            [languages]="languages" [race]="race" [showExportButton]="false"
                            [showName]="true"></app-races-header>
        </div>
      }
      @if (filteringEnabled) {
        @if (isAdmin) {
          <!-- Filter part for admin -->
        <div class="filter-wrapper">
          <div class="d-flex justify-content-between">
            <div class="d-flex">
              <div class="d-flex flex-column flex-xxl-row">
                <div class="pe-2">
                  <app-search-rounded [name]="name" [placeholder]="t('explore.search')"
                                      (searchEmitter)="handleSearchInput($event)"></app-search-rounded>
                </div>
                @if (raceFilteringEnabled) {
                  <div class="w-180 d-flex ps-2 pe-2">
                    <app-select (ngModelChange)="handleRaceSelection($event)" [defaultLabel]="t('app.common.all')"
                                [placeholder]="t('app.common.race')" [defaultValue]="undefined"
                                [fullWidthDropdown]="true" [hasDefault]="allowOnlyRaceView ? false: true"
                                [items]="raceIds" [translatedLabels]="raceNames" [ngModel]="raceId"/>
                  </div>
                }
                <div class="w-180 d-flex">
                  <app-select [hasDefault]="true" [items]="competitorStatuses" [ngModel]="selectedStatus"
                              (ngModelChange)="handleStatusSelection($event)" [defaultValue]="undefined"
                              [placeholder]="t('competitor.table.status')" [defaultLabel]="t('app.common.all')"
                              [labels]="competitorStatuses" [fullWidthDropdown]="true"/>
                </div>
                @if (filteringOptions.get('sex')) {
                  <div class="w-180 d-flex ps-2">
                    <app-select (ngModelChange)="handleGenderSelection($event)" [placeholder]="t('app.common.gender')"
                                [defaultLabel]="t('app.common.all')" [defaultValue]="undefined"
                                [fullWidthDropdown]="true" [hasDefault]="true" [items]="genders" [ngModel]="gender"
                                labelKey="id" labelKeyPrefix="app.common.gender." valueKey="id"/>
                  </div>
                }
                @if (filteringOptions.get('category') && categories.length > 0) {
                  <div class=" w-180 d-flex ps-2">
                    <app-select (ngModelChange)="handleCategorySelection($event)" [defaultLabel]="t('app.common.all')"
                                [placeholder]="t('competitor.table.category')" [defaultValue]="undefined"
                                [fullWidthDropdown]="true" [hasDefault]="true" [items]="categories" [labelKey]="'name'"
                                [ngModel]="category" [valueKey]="'id'"/>
                  </div>
                }
              </div>

              <ng-content select="[slot='competitorTableAdminLeadingWidgets']"></ng-content>
            </div>
            <ng-content select="[slot='competitorTableAdminTrailingWidgets']"></ng-content>
          </div>
          <div class="d-flex justify-content-end align-items-end pb-20">
            <app-competitor-count [raceId]="race?.id" [event]="event"
                                  [displayCount]="measurements ? ['total',  'withStartNumber', 'started', 'finished', 'disqualified', 'didNotFinished'] : ['total', 'paidOrConfirmedCount', 'withStartNumber']"/>
          </div>
        </div>
        } @else {
          <!-- Filter part for public-->
          <div class="contestants-filter mb-3">
            <div class="d-flex flex-column justify-content-lg-between flex-lg-row">
              <div class="me-lg-3 pb-2">
                <app-search [searchBarClass]="'extra-small'" [placeholder]="t('explore.search')"
                            (searchQuery)="handleSearchInput($event)" [inputValue]="name"/>
              </div>
              <form #f>
                <div class="contestants-filter__grid">
                  <div class="contestants-filter__grid-inner">
                    @if (raceFilteringEnabled && event?.racesList?.length ?? 0 > 0) {
                      <div class="race-dropdown-box">
                        <div class="dropdown-small flex-grow-1" container="body" ngbDropdown>
                          <div class="dropdown" id="raceDropdown" ngbDropdownToggle>
                          <span class="trim-dropdown-text">
                          @if (raceId) {
                            <app-language-output [hrLabel]="race?.name" [enLabel]="race?.nameEng"
                                                 [srLabel]="race?.nameSr" [bsLabel]="race?.nameBs"
                                                 [itLabel]="race?.nameIta" [siLabel]="race?.nameSlo"
                                                 [defaultLanguage]="event?.defaultLanguage" [languages]="languages"/>
                          } @else {
                            {{t("app.common.race")}}
                          }
                          </span>
                          </div>
                          <div aria-labelledby="raceDropdown" ngbDropdownMenu>
                            @if (!allowOnlyRaceView) {
                              <button (click)="handleRaceSelection()" ngbDropdownItem>
                                {{t("app.common.all")}}
                                @if (!raceId) {
                                  <i class="bi bi-check"></i>
                                }
                              </button>
                            }
                            @for (item of event?.racesList;track item) {
                              <button ngbDropdownItem (click)="handleRaceSelection(item.id)">
                                <app-language-output [hrLabel]="item?.name" [enLabel]="item?.nameEng"
                                                     [srLabel]="item?.nameSr" [bsLabel]="item?.nameBs"
                                                     [itLabel]="item?.nameIta" [siLabel]="item?.nameSlo"
                                                     [defaultLanguage]="event?.defaultLanguage"
                                                     [languages]="languages"/>
                                @if (item.id === raceId) {
                                  <i class="bi bi-check"></i>
                                }
                              </button>
                            }
                          </div>
                        </div>
                      </div>
                    }
                    @if (filteringOptions.get('sex')) {
                      <div class="dropdown-small" container="body" ngbDropdown>
                        <div class="dropdown" id="genderDropdown" ngbDropdownToggle>
                          {{gender ? t("app.common.gender." + gender) : t("competitor.table.gender")}}
                        </div>
                        <div aria-labelledby="genderDropdown" ngbDropdownMenu>
                          <button (click)="handleGenderSelection()" ngbDropdownItem>
                            {{t("app.common.all")}}
                            @if (!gender) {
                              <i class="bi bi-check"></i>
                            }
                          </button>
                          @for (item of genders;track item.id) {
                            <button ngbDropdownItem (click)="handleGenderSelection(item.id)">
                              {{t("app.common.gender." + item.id)}}
                              @if (item.id === gender) {
                                <i class="bi bi-check"></i>
                              }
                            </button>
                          }
                        </div>
                      </div>
                    }

                    @if (filteringOptions.get('category') && categories.length > 0) {
                      <div class="dropdown-small" container="body" ngbDropdown>
                        <div class="dropdown" id="categoryDropdown" ngbDropdownToggle>
                          {{category ? category.name : t("competitor.table.category")}}
                        </div>
                        <div aria-labelledby="categoryDropdown" ngbDropdownMenu>
                          <button (click)="handleCategorySelection()" ngbDropdownItem>
                            {{t("app.common.all")}}
                            @if (!category) {
                              <i class="bi bi-check"></i>
                            }
                          </button>
                          @for (categoryItem of categories;track categoryItem) {
                            <button ngbDropdownItem (click)="handleCategorySelection(categoryItem)">
                              {{categoryItem.name}}
                              @if (categoryItem?.id === category?.id) {
                                <i class="bi bi-check"></i>
                              }
                            </button>
                          }
                        </div>
                      </div>
                    }
                  </div>
                </div>
              </form>
            </div>
          </div>
        }
      }
      <app-loader [isLoading]="isLoading"></app-loader>
      <div class="table-responsive competitor-table" [ngClass]="{'pt-16 mb-16': showHeader}">
        @if (competitorTableData.length > 0) {
          <div>
            <div [ngClass]="{'scrollable-table': !showLoadMoreButton}"
                 (scroll)="!(gender || name || category) ? onScroll($event): undefined">

              <!--              Mobile list item-->
              <div class="d-flex flex-column d-flex d-lg-none">
                @for (competitor of competitorTableData;track competitor;let idx = $index;let last = $last) {
                  <ng-container *ngTemplateOutlet="competitorMobileItem; context: {
                  competitor: competitor,
                  isAdmin: isAdmin,
                  last: last
                }"></ng-container>
                }
              </div>

              <div class="d-flex">
                <div class="flex-grow-1" style="overflow-x: auto;">
                  <div class="d-none d-lg-flex">
                    <app-sortable-table [cssClass]="'table align-middle header'" [items]="competitorTableData"
                                        (onSort)="sortCompetitors()">
                      <thead class="table-header">
                      <tr>
                        @for (field of competitorTableSelectedColumns | filterCompetitorTableRowData;track
                          field) {
                          <th scope="col" [sortBy]="[field]"
                              [attr.data-type]="(field === 'identityCardExpires' || field === 'startTime' || field === 'birthday' || field === 'created' || field === 'modified') ? 'date' : '' "
                              [ngClass]="assignClass(field)">
                            <div class="d-flex align-items-end justify-content-start">
                              <div class="col-name-holder">
                                {{t('competitor.table.' + field)}}
                              </div>
                              <div class="icon-holder"></div>
                            </div>
                          </th>
                        }
                        @if ((tableMode === CompetitorTableType.RACE_VIEW || tableMode ===
                          CompetitorTableType.TEAM_MEMBER_VIEW)) {
                          @for (customColumn of competitorTableSelectedCustomColumns;track customColumn) {
                            <th scope="col">
                              <div class="d-flex align-items-end justify-content-start">
                                <div class="col-name-holder">
                                  <app-language-output [defaultLanguage]="event?.defaultLanguage"
                                                       [enLabel]="customColumn.nameEng" [hrLabel]="customColumn.name"
                                                       [itLabel]="customColumn.nameIta" [languages]="languages"
                                                       [siLabel]="customColumn.nameSlo" [srLabel]="customColumn.nameSr"
                                                       [bsLabel]="customColumn.nameBs"/>
                                </div>
                                <div class="icon-holder"></div>
                              </div>
                            </th>
                          }
                          @for (item of competitorTableSelectedAdditionalPricingColumns;track item) {
                            <th scope="col">
                              <div class="d-flex align-items-end justify-content-start">
                                <div class="col-name-holder">
                                  <app-language-output [defaultLanguage]="event?.defaultLanguage"
                                                       [enLabel]="item.nameEng" [hrLabel]="item.name"
                                                       [itLabel]="item.nameIta" [languages]="languages"
                                                       [siLabel]="item.nameSlo" [bsLabel]="item.nameBs"
                                                       [srLabel]="item.nameSr"/>
                                </div>
                                <div class="icon-holder"></div>
                              </div>
                            </th>
                          }
                        }
                      </tr>
                      </thead>
                      @if (isAdmin) {
                        <tr app-table-header-separator></tr>
                      }
                      <tbody #tbody>
                        @for (competitor of competitorTableData;track competitor.id;let idx = $index) {
                          <tr [class.clickable]="isAdmin" [ngStyle]="$last ? {'border-color': 'transparent'} : {}">
                            @for (column of competitorTableSelectedColumns | filterCompetitorTableRowData;track column) {
                              <td class="center-align">
                            <span class="text-truncate fs-15">
                              @switch (column) {
                                @case ('startNumber') {
                                  <span [class.opacity-25]="!competitor.startNumber">{{
                                      competitor.startNumber ?? '00'
                                    }}</span>
                                }
                                @case ('startBlock') {
                                  <span [class.opacity-25]="!competitor.startBlock">{{
                                      competitor.startBlock ?? '00'
                                    }}</span>
                                }
                                @case ('status') {
                                  <div class="d-flex">
                                    <div class="badge-holder__badge finished">
                                      <span class="text-uppercase">
                                        {{competitor.status ? competitor.status : "-"}}
                                      </span>
                                    </div>
                                  </div>
                                }
                                @case ('paymentStatus') {
                                  <div class="d-flex">
                                    @if (competitor.paymentStatus !== null && competitor.paymentStatus !== undefined) {
                                      <div class="badge-holder__badge no-border"
                                           [class.finished]="competitor.paymentStatus === AmountStatus.EXACT"
                                           [class.underpaid]="competitor.paymentStatus === AmountStatus.UNDERPAID"
                                           [class.overpaid]="competitor.paymentStatus === AmountStatus.OVERPAID"
                                           [class.to-be-started]="competitor.paymentStatus === AmountStatus.NOT_PAID">
                                       <span class="text-uppercase">
                                        {{
                                           t(
                                             "account.statements.amountStatus." +
                                             competitor.paymentStatus +
                                             (
                                               !isAdmin && competitor.paymentStatus === AmountStatus.EXACT
                                                 ? ".public"
                                                 : ""
                                             )
                                           )
                                         }}
                                      </span>
                                    </div>
                                    } @else {
                                      -
                                    }
                                  </div>
                                }
                                @case ('created') {
                                  {{competitor.created ?? '' | localizedDate:'shortDate'}}
                                }
                                @case ('modified') {
                                  {{competitor.modified ?? '' | localizedDate:'short'}}
                                }
                                @case ('birthday') {
                                  {{competitor.birthday ?? '' | localizedDate:'shortDate'}}
                                }
                                @case ('startTime') {
                                  {{
                                    competitor.startTime ? (competitor.startTime |
                                      localizedDate:'dd.MM.yyyy HH:mm:ss.SSS') : '-'
                                  }}
                                }
                                @case ('raceName') {
                                  <span class="trim-text">
                                      <ng-container>
                                       <app-language-output [defaultLanguage]="event?.defaultLanguage"
                                                            [enLabel]="competitor.raceNameEn"
                                                            [hrLabel]="competitor.raceName"
                                                            [itLabel]="competitor.raceNameIta" [languages]="languages"
                                                            [siLabel]="competitor.raceNameSlo"
                                                            [bsLabel]="competitor.raceNameBs"
                                                            [srLabel]="competitor.raceNameSr"/>
                                    </ng-container>
                                    </span>
                                }
                                @case ('fee') {
                                  <span class="d-flex align-items-center" style="max-width: 152px; overflow: hidden;">
                                    <ng-container>
                                      @if (competitor?.raceCommercialItem) {
                                        <div class="text-truncate" style="min-width: 0;"
                                             [ngbTooltip]="getCompetitorName(competitor)" placement="left">
                                          <app-language-output [defaultLanguage]="event?.defaultLanguage"
                                                               [enLabel]="competitor?.raceCommercialItem?.nameEng"
                                                               [hrLabel]="competitor?.raceCommercialItem?.name"
                                                               [itLabel]="competitor?.raceCommercialItem?.nameIta"
                                                               [languages]="languages"
                                                               [siLabel]="competitor?.raceCommercialItem?.nameSlo"
                                                               [bsLabel]="competitor?.raceCommercialItem?.nameBs"
                                                               [srLabel]="competitor?.raceCommercialItem?.nameSr"/>
                                        </div>
                                        @if (competitor.fee) {
                                          <i class="bi bi-info-circle info-icon ps-2" ngbTooltip="{{ competitor.fee }}"
                                             placement="left"></i>
                                        }
                                      } @else {
                                        <div class="text-truncate" style="min-width: 0;"
                                             [ngbTooltip]="competitor.fee || '-'" placement="left">
                                          @if (competitor.fee) {
                                            {{competitor.fee}}
                                          } @else {
                                            -
                                          }
                                        </div>
                                      }
                                    </ng-container>
                                  </span>
                                }
                                @case ('sex') {
                                  <div class="d-flex justify-content-center">
                                    @if (competitor?.sex === '1') {
                                      <div class="badge-holder__badge gender-badge-man">
                                        <span class="text-uppercase">{{t('app.common.gender.short.1')}}</span>
                                      </div>
                                    } @else if (competitor?.sex === '2') {
                                      <div class="badge-holder__badge gender-badge-women">
                                        <span class="text-uppercase">{{t('app.common.gender.short.2')}}</span>
                                      </div>
                                    } @else {
                                      <div class="badge-holder__badge gender-badge-man">
                                        <span class="text-uppercase">-</span>
                                      </div>
                                    }
                                  </div>
                                }
                                @default {
                                  <span class="text-truncate"
                                        style="max-width: 152px; display: inline-block; overflow: hidden; white-space: nowrap;"
                                        [ngbTooltip]="competitor && competitor[column] != null ? competitor[column]?.toString() : '-'"
                                        placement="left">
                                    {{competitor?.[column] ?? "-"}}
                                  </span>
                                }
                              }
                            </span>
                              </td>
                            }
                            @if (tableMode === CompetitorTableType.RACE_VIEW || tableMode
                            === CompetitorTableType.TEAM_MEMBER_VIEW) {
                              @for (customColumn of competitorTableSelectedCustomColumns;track customColumn) {
                                <td class="center-align">
                                    <span class="text-wrap">
                                {{customColumn | competitorFieldValue: competitor ?? "-"}}
                                </span>
                                </td>
                              }
                              @for (item of competitorTableSelectedAdditionalPricingColumns;track item) {
                                <td class="center-align">
                                 <span class="text-wrap">
                                    {{item | competitorAdditionalPricingValue: competitor ?? "-"}}
                                 </span>
                                </td>
                              }
                            }
                          </tr>
                        }
                      </tbody>
                    </app-sortable-table>

                  </div>
                </div>
                <div class="d-lg-block d-none">
                  <table class="table dark-header table-last-row-no-border" style="table-layout: auto !important;">
                    <thead>
                    <tr>
                      <th class="more-th text-end width-50" [class.admin]="isAdmin">
                        <app-multiselect-dropdown [options]="options" [ngModel]="competitorTableSelectedColumns"
                                                  (ngModelChange)="onSelectedFieldsChange($event)"
                                                  buttonIconClass="assets/icons/filter-icon-alt.svg" [iconSize]="24"
                                                  [isTableHeading]="true" [isButton]="true"
                                                  [iconClass]="'menu-icon--small'"/>
                      </th>
                    </tr>
                    </thead>
                    @if (isAdmin) {
                      <tr app-table-header-separator></tr>
                    }
                    <tbody>
                      @for (competitor of competitorTableData;track competitor;let idx = $index) {
                        <tr [ngStyle]="$last ? {'border-color': 'transparent'} : {}">
                          <td class="more-td text-end center-align width-50">
                            @if (isAdmin) {
                              <app-competitor-table-dropdown-actions-row
                                (chronometarRaceCompetitorStartStop)="onChronometarRaceCompetitorStartStop($event)"
                                (onEditCompetitorEventEmitter)="onEditCompetitor($event)"
                                (onEditTeamMemberButtonClick)="editTeamMemberButtonClick($event)"
                                (onDeleteCompetitorEventEmitter)="onDeleteCompetitor()"
                                [applicationFormSettingsList]="applicationFormSettingsList"
                                [applicationFormSettings]="applicationFormSettings" [competitor]="competitors[idx]"
                                [competitors]="competitors" [event]="event" [index]="idx" [languages]="languages"
                                [isTeamMembersManagement]="isTeamMembersManagement" [measurements]="measurements"
                                [raceSettingsList]="raceSettingsList" [raceSettings]="raceSettings"
                                [race]="race ?? (event?.racesList | getByField:'id':competitors[idx].raceId)"
                                [tableMode]="tableMode"/>
                            } @else {
                              <div></div>
                            }

                          </td>
                        </tr>
                      }

                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            @if (hasMore && showLoadMoreButton && !(gender || name || category)) {
              @if (isAdmin) {
                <app-admin-load-more (loadMore)="loadMore()"/>
              } @else {
                <div class="d-flex justify-content-center load-more-wrapper py-5">
                  <app-button-alt (onClickCallback)="loadMore()" [borderColor]="'var(--teal-500)'"
                                  [buttonColor]="'var(--teal-500)'" [textColor]="'white'"
                                  [text]="t('app.common.load.more')"></app-button-alt>
                </div>
              }
            }
          </div>
        } @else if (showEmptyState) {
          <div class="px-3 px-lg-4 pt-2">
            <app-empty-state [contentKeys]="['emptyState.not.able.to.find', 'emptyState.not.in.progress.try.later']"/>
          </div>
        }
        @if (!this.showLoadMoreButton && showBorderBottom) {
          <div class="table-separator"></div>
        }
      </div>
    }
  </div>

  <ng-template #competitorMobileItem let-competitor="competitor" let-isAdmin="isAdmin" let-last="last">
    <ng-container
      *ngIf="competitor | competitorMobileFields: raceSettingsList : applicationFormSettingsList : tableMode : allowedVisibilityTypes : isAdmin : event as fields">
      <div class="d-flex flex-column fs-14 grey-neutral-600" [ngClass]="{ 'competitor-item-mobile': true }" [ngStyle]="{
         'border-bottom': last ? 'none' : '1px solid var(--teal-200)',
         'padding-top': '16px',
         'padding-bottom': last ? '0' : '16px'
       }">

        <!-- Name + Team -->
        @for (field of fields;track field) {
          @switch (field) {
            @case ('teamName') {
              <div class="pb-2 fw-bold">{{competitor?.teamName ?? '-'}}</div>
            }
            @case ('fullName') {
              <div class="pb-2 fw-bold">{{competitor?.fullName ?? '-'}}</div>
            }
          }
        }

        <!-- Team Members -->
        @if (fields.includes('teamMembers')) {
          <div class="d-flex flex-wrap pb-2 fw-300">
            @for (member of competitor.teamMembers;track member;let lastMember = $last) {
              <ng-container
                *ngIf="member | competitorMobileFields: raceSettingsList : applicationFormSettingsList : tableMode : allowedVisibilityTypes : isAdmin : event : true as memberFields">
                @for (memberField of memberFields;track memberField;let lastMemberField = $last) {
                  @switch (memberField) {
                    @case ('sex') {
                      <span class="text-uppercase">
                {{(member.sex === '1' || member.sex === '2') ? t('app.common.gender.short.' + member.sex) : "-"}}
              </span>
                    }
                    @default {
                      {{member[memberField] ?? "-"}}
                    }
                  }
                  <span class="pe-1">{{lastMemberField ? '' : ','}}</span>
                }
              </ng-container>
              @if (!lastMember) {
                <div class="item-separator"></div>
              }
            }
          </div>
        }

        <!-- Gender, Country, Club, Start Number -->
        <div class="d-flex flex-wrap">
          @for (field of fields;track field) {
            @switch (field) {
              @case ('startNumber') {
                <span [class.opacity-25]="!competitor?.startNumber">{{competitor?.startNumber ?? '00'}}</span>
              }
              @case ('sex') {
                <div class="item-separator"></div><span>
                  <div class="d-flex justify-content-center">
                    @switch (competitor?.sex) {
                      @case ('1') {
                        <span class="text-uppercase">{{t('app.common.gender.short.1')}}</span>
                      }
                      @case ('2') {
                        <span class="text-uppercase">{{t('app.common.gender.short.2')}}</span>
                      }
                      @default {
                        <span class="text-uppercase">-</span>
                      }
                    }
            </div>
          </span>
              }
              @case ('countryShort') {
                <div class="item-separator"></div>
                <div>{{competitor.countryShort ?? '-'}}</div>
              }
              @case ('club') {
                <div class="item-separator"></div>
                <div>{{competitor.club ?? '-'}}</div>
              }
            }
          }
        </div>

        <!-- Payment & Category -->
        <div class="d-flex pt-2 align-items-center">
          @for (field of fields;track field) {
            @switch (field) {
              @case ('paymentStatus') {
                <div class="badge-holder__badge" [class.finished]="competitor.paymentStatus === AmountStatus.EXACT"
                     [class.in-progress]="competitor.paymentStatus === AmountStatus.UNDERPAID"
                     [class.gender-badge-man]="competitor.paymentStatus === AmountStatus.OVERPAID"
                     [class.to-be-started]="competitor.paymentStatus === AmountStatus.NOT_PAID">
            <span class="text-uppercase">
              {{
                t(
                  'account.statements.amountStatus.' +
                  competitor.paymentStatus +
                  (!isAdmin && competitor.paymentStatus === AmountStatus.EXACT ? '.public' : '')
                )
              }}
            </span>
                </div>
                @if (competitor.categoryLabel) {
                  <div class="item-separator"></div>
                }
              }
              @case ('categoryLabel') {
                <div>
                  {{t('race.registration.settings.ageCategory')}} : {{competitor.categoryLabel ?? "-"}}
                </div>
              }
            }
          }
        </div>
      </div>
    </ng-container>
  </ng-template>
</ng-container>

